export enum REDIRECT_HANDLER_CONSTANTS {
  oauthCallback = 'OauthCallback',
}
